<div class="list-page">
  <mat-tab-group [(selectedIndex)]="ylatabIndex" mat-stretch-tabs="false">
    <mat-tab label="Kirjausehdotus">
      <ng-template matTabContent>
        <!-- Yläpalkki: kategoriavalinta + globaali prompt -->
        <div style="display: flex; gap: 12px; align-items: center; padding: 12px; border-bottom: 1px solid #eee">
          <mat-form-field style="width: 380px; margin-bottom: -1.25em" subscriptSizing="dynamic">
            <mat-label>Kategoria</mat-label>
            <mat-select [formField]="kategoriaValinta" (selectionChange)="valitseKategoria($event.value)" [compareWith]="vertaileKategoriat">
              @for (k of LLM_KATEGORIAT_UI; track k) {
                <mat-option [value]="k" style="font-family: monospace; font-size: 12px">{{ k }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button (click)="avaaGlobaaliPromptDialog()">
            <mat-icon>edit_note</mat-icon>
            Globaali prompt
            @if (globaaliPromptVersioHeader() !== null) {
              <span style="margin-left: 6px; font-size: 11px; color: #1976d2; font-family: monospace">v{{ globaaliPromptVersioHeader() }}</span>
            }
          </button>
        </div>

        <div class="tab-content" style="padding: 0; margin-top: 1rem">
          @if (valittuKategoria(); as kategoria) {
            <mat-tab-group [(selectedIndex)]="alivalilehtiIndex" mat-stretch-tabs="false">
              <mat-tab label="Prompti">
                <ng-template matTabContent>
                  <app-kategoria-promptti
                    [kategoria]="kategoria"
                    [uusin]="kategoriapromptUusin().get(kategoria)"
                    [muokattu]="kategoriapromptMuokattu().get(kategoria) ?? ''"
                    [lataa]="kategoriapromptLataa().has(kategoria)"
                    [tallennetaan]="kategoriapromptTallennetaan().has(kategoria)"
                    [historia]="kategoriapromptHistoria().get(kategoria) ?? []"
                    [naytaHistoria]="naytaKategoriapromptHistoriaJoukko().has(kategoria)"
                    [esikatselu]="esikatseluKategoriaVersio().get(kategoria) ?? null"
                    [tilikarttaRajat]="kategoriapromptTilikarttaRajatMuokattu().get(kategoria) ?? []"
                    (muokattuChange)="asetaKategoriapromptMuokattu(kategoria, $event)"
                    (tallenna)="tallennaKategoriaprompt(kategoria)"
                    (toggleHistoria)="toggleKategoriapromptHistoria(kategoria)"
                    (esikatsele)="esikatseleKategoriaVersio(kategoria, $event)"
                    (suljeEsikatselu)="suljeEsikatseluKategoria(kategoria)"
                    (tilikarttaRajatChange)="asetaTilikarttaRajat(kategoria, $event)"
                    (palautaVersio)="palautaKategoriaVersio(kategoria, $event)"
                  ></app-kategoria-promptti>
                </ng-template>
              </mat-tab>
              <mat-tab label="Testisetit">
                <ng-template matTabContent>
                  <app-kategoria-setit
                    [kategoria]="kategoria"
                    [setit]="setit().get(kategoria) ?? []"
                    [setitLataa]="setitLataa().has(kategoria)"
                    [valittuSetti]="valittuSetti()"
                    [settiTestitapaukset]="settiTestitapaukset()"
                    [settiTestitapauksetLataa]="settiTestitapauksetLataa()"
                    [poistetaanJasenyys]="poistetaanJasenyys()"
                    [luoSettiKaynnissa]="luoSettiKaynnissa()"
                    [(uusiSettiNimi)]="uusiSettiNimi"
                    (luoSetti)="luoUusiSetti()"
                    (poistaSetti)="poistaSetti($event)"
                    (avaaSetti)="avaaSetti($event)"
                    (suljeSetti)="suljeSetti()"
                    (poistaJasenyys)="poistaJasenyys($event)"
                  ></app-kategoria-setit>
                </ng-template>
              </mat-tab>
              <mat-tab label="Testiajot">
                <ng-template matTabContent>
                  <app-kategoria-ajot
                    [kategoria]="kategoria"
                    [testiajot]="testiajot().get(kategoria) ?? []"
                    [testiajotLataa]="testiajotLataa().has(kategoria)"
                    [setit]="setit().get(kategoria) ?? []"
                    [mallit]="mallit"
                    [(valittuMalli)]="valittuMalli"
                    [(valittuAjoSetti)]="valittuAjoSetti"
                    [testiajoKaynnissa]="testiajoKaynnissa()"
                    [tuloksetTestiajoAvain]="tuloksetTestiajoAvain()"
                    [tulokset]="tulokset()"
                    [tuloksetLataa]="tuloksetLataa()"
                    [naytaPrompttiAvaimet]="naytaPrompttiAvaimet()"
                    [kasiteltyLkm]="kasiteltyLkm()"
                    (aloitaTestiAjo)="aloitaTestiAjo()"
                    (testiajoPaneelAuki)="onTestiajoPaneelAuki($event)"
                    (testiajoPaneelKiinni)="onTestiajoPaneelKiinni($event)"
                    (togglePrompt)="togglePrompt($event)"
                  ></app-kategoria-ajot>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          }
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Luottokorttilasku">
      <ng-template matTabContent>
        <app-luottokorttilasku-prompt></app-luottokorttilasku-prompt>
      </ng-template>
    </mat-tab>
    <mat-tab label="Palautteet">
      <ng-template matTabContent>
        <app-llm-kirjausehdotus-palaute></app-llm-kirjausehdotus-palaute>
      </ng-template>
    </mat-tab>
    <mat-tab label="Tositteen luku">
      <ng-template matTabContent>
        <app-tosite-luku></app-tosite-luku>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
